/**
 *
 * @param fieldName
 * @param tagName
 * @param type
 * @returns
 */
export const setAllowedFormats = (
  fieldName: string,
  tagName: string,
  type: 'STRING' | 'DATE' | 'MONEY'
) => {
  switch (type) {
    case 'STRING':
      return [
        { title: 'Sin_formato', value: null },
        { title: 'Mayusculas', value: 'uppercase' },
        { title: 'Minusculas', value: 'lowercase' },
        { title: 'Capitalizar', value: 'capitalize' },
      ].map((item: any) => ({
        title: fieldName + ' - ' + item.title,
        value: item.value ? `${tagName}|${item.value}` : tagName,
      }))
    case 'DATE':
      return [
        { title: 'Sin_formato', value: null },
        {
          title: 'ej. a los 23 días del mes de mayo de 2019',
          value: 'textdate_1',
        },
        { title: 'ej. jueves, 23 de mayo de 2019', value: 'textdate_2' },
        { title: 'ej. 11 de marzo del 2019', value: 'textdate_3' },
        { title: 'dd/mm/yyyy', value: 'dd/mm/yyyy' },
        { title: 'mm/dd/yyyy', value: 'mm/dd/yyyy' },
        { title: 'yyyy-mm-dd', value: 'yyyy-mm-dd' },
        { title: 'dd-mm-yyyy', value: 'dd-mm-yyyy' },
        { title: 'D', value: 'D' },
        { title: 'dddd', value: 'dddd' },
        { title: 'MMMM', value: 'MMMM' },
        { title: 'YYYY', value: 'YYYY' },
      ].map((item: any) => ({
        title: fieldName + ' - ' + item.title,
        value: item.value ? `${tagName}|${item.value}` : tagName,
      }))
    case 'MONEY':
      return [
        { title: 'Sin_formato', value: null },
        { title: 'ej. TRES MILLONES CON VEINTIOCHO', value: 'textnumber' },
        { title: '0.0,00', value: '0.0,00' },
        { title: '0,0.00', value: '0,0.00' },
      ].map((item: any) => ({
        title: fieldName + ' - ' + item.title,
        value: item.value ? `${tagName}|${item.value}` : tagName,
      }))
  }
}
